module.exports = __webpack_public_path__ + "img/call.39fb87de.png";